<div class="space-y-5">

  <!-- ══ LEVEL 1: Offering selection ══ -->
  <ng-container *ngIf="!selectedOffering">

    <div class="flex items-center gap-4">
      <div class="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
        <svg class="w-5 h-5 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25"/>
        </svg>
      </div>
      <div>
        <h2 class="text-2xl font-bold text-gray-800">Content Publisher</h2>
        <p class="text-sm text-gray-500 mt-0.5">Choose a subject to manage its learning materials</p>
      </div>
    </div>

    <div class="relative">
      <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
      </svg>
      <input
        type="text"
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearch()"
        placeholder="Search by subject, form or year..."
        class="w-full pl-9 pr-4 py-2.5 rounded-xl border border-gray-200 bg-white text-sm text-gray-800 placeholder:text-gray-400 outline-none focus:border-primary transition-colors"
      />
    </div>

    <app-loader-component [loading]="loading" message="Loading offerings..."></app-loader-component>

    <div *ngIf="errorMsg && !loading" class="flex items-center gap-2 p-3 rounded-xl bg-red-50 border border-red-200 text-sm text-red-600">
      <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 8v4m0 4h.01"/></svg>
      {{ errorMsg }}
    </div>

    <div *ngIf="!loading && !errorMsg && filteredOfferings.length === 0" class="flex flex-col items-center justify-center py-16 text-center">
      <svg class="w-10 h-10 text-gray-300 mb-3" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25"/>
      </svg>
      <p class="text-sm font-medium text-gray-600">No subjects found</p>
      <p class="text-xs text-gray-400 mt-1">Try a different search, or create subject offerings first.</p>
    </div>

    <div *ngIf="!loading && pagedOfferings.length > 0" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <button
        *ngFor="let offering of pagedOfferings"
        (click)="selectOffering(offering)"
        class="text-left bg-white rounded-2xl border border-gray-200 p-5 hover:border-primary hover:shadow-md transition-all cursor-pointer group"
      >
        <div class="flex items-center gap-3 mb-4">
          <div class="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 text-primary font-bold text-sm">
            {{ (offering.subjectName || 'S').charAt(0).toUpperCase() }}
          </div>
          <div class="min-w-0 flex-1">
            <p class="font-bold text-gray-800 truncate group-hover:text-primary transition-colors">{{ offering.subjectName || '—' }}</p>
            <p class="text-xs text-gray-400 truncate">{{ offering.formName || offering.grade || '—' }}</p>
          </div>
          <svg class="w-4 h-4 text-gray-300 group-hover:text-primary transition-colors flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
          </svg>
        </div>
        <div class="flex items-center gap-2">
          <span class="inline-block px-2 py-0.5 rounded-md bg-gray-100 border border-gray-200 text-xs font-semibold text-gray-600">
            {{ offering.academicYearName || '—' }}
          </span>
          <span *ngIf="offering.assignedTeacherName" class="text-xs text-gray-400 truncate">· {{ offering.assignedTeacherName }}</span>
        </div>
      </button>
    </div>

    <div *ngIf="filteredOfferings.length > size" class="flex items-center justify-between pt-2">
      <span class="text-xs text-gray-400">Showing {{ getMinValue(page * size + size, filteredOfferings.length) }} of {{ filteredOfferings.length }}</span>
      <div class="flex items-center gap-1">
        <button (click)="prevPage()" [disabled]="!hasPrev" class="flex items-center gap-1 px-3 py-1.5 rounded-lg border border-gray-200 text-sm text-gray-700 font-medium cursor-pointer hover:bg-gray-50 transition-colors disabled:opacity-40 disabled:cursor-not-allowed">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/></svg>
          Prev
        </button>
        <span class="px-3 py-1.5 text-sm text-gray-600">{{ page + 1 }} / {{ totalPages }}</span>
        <button (click)="nextPage()" [disabled]="!hasNext" class="flex items-center gap-1 px-3 py-1.5 rounded-lg border border-gray-200 text-sm text-gray-700 font-medium cursor-pointer hover:bg-gray-50 transition-colors disabled:opacity-40 disabled:cursor-not-allowed">
          Next
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>
        </button>
      </div>
    </div>

  </ng-container>


  <!-- ══ LEVEL 2: Topic selection ══ -->
  <ng-container *ngIf="selectedOffering && !selectedTopic">

    <div class="flex items-center gap-2 text-sm">
      <button (click)="backToOfferings()" class="text-primary font-semibold hover:underline cursor-pointer">Subjects</button>
      <svg class="w-3.5 h-3.5 text-gray-400" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>
      <span class="text-gray-500 truncate">{{ selectedOffering.subjectName }}</span>
    </div>

    <div class="flex items-start gap-4 p-4 rounded-2xl border border-gray-200 bg-gray-50">
      <div class="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 text-primary font-bold text-sm">
        {{ (selectedOffering.subjectName || 'S').charAt(0).toUpperCase() }}
      </div>
      <div>
        <p class="font-bold text-gray-800">{{ selectedOffering.subjectName }}</p>
        <p class="text-xs text-gray-400 mt-0.5">{{ selectedOffering.formName || selectedOffering.grade }} · {{ selectedOffering.academicYear }}</p>
      </div>
    </div>

    <div>
      <h3 class="text-base font-bold text-gray-800 mb-1">Select a Topic</h3>
      <p class="text-sm text-gray-500">Pick a topic to view or add learning materials</p>
    </div>

    <app-loader-component [loading]="topicsLoading" message="Loading topics..."></app-loader-component>

    <div *ngIf="topicsError && !topicsLoading" class="flex items-center gap-2 p-3 rounded-xl bg-red-50 border border-red-200 text-sm text-red-600">
      <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 8v4m0 4h.01"/></svg>
      {{ topicsError }}
    </div>

    <div *ngIf="!topicsLoading && !topicsError && topics.length === 0" class="flex flex-col items-center justify-center py-16 text-center">
      <svg class="w-10 h-10 text-gray-300 mb-3" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/>
      </svg>
      <p class="text-sm font-medium text-gray-600">No topics found</p>
      <p class="text-xs text-gray-400 mt-1">Add topics to this subject before publishing content.</p>
    </div>

    <div *ngIf="!topicsLoading && topics.length > 0" class="space-y-2">
      <button
        *ngFor="let topic of topics; let i = index"
        (click)="selectTopic(topic)"
        class="w-full text-left flex items-center gap-4 p-4 rounded-xl border border-gray-200 bg-white hover:border-primary hover:bg-primary/5 transition-all cursor-pointer group"
      >
        <div class="w-8 h-8 rounded-lg bg-gray-100 border border-gray-200 flex items-center justify-center flex-shrink-0">
          <span class="text-xs font-bold text-gray-400">{{ i + 1 }}</span>
        </div>
        <div class="flex-1 min-w-0">
          <p class="font-semibold text-gray-800 group-hover:text-primary transition-colors truncate">{{ topic.title }}</p>
          <p *ngIf="topic.description" class="text-xs text-gray-400 truncate mt-0.5">{{ topic.description }}</p>
        </div>
        <svg class="w-4 h-4 text-gray-300 group-hover:text-primary transition-colors flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
        </svg>
      </button>
    </div>

  </ng-container>


  <!-- ══ LEVEL 3: Materials ══ -->
  <ng-container *ngIf="selectedOffering && selectedTopic">

    <div class="flex items-center gap-2 text-sm flex-wrap">
      <button (click)="backToOfferings()" class="text-primary font-semibold hover:underline cursor-pointer">Subjects</button>
      <svg class="w-3.5 h-3.5 text-gray-400" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>
      <button (click)="backToTopics()" class="text-primary font-semibold hover:underline cursor-pointer truncate max-w-32">{{ selectedOffering.subjectName }}</button>
      <svg class="w-3.5 h-3.5 text-gray-400" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>
      <span class="text-gray-500 truncate">{{ selectedTopic.title }}</span>
    </div>

    <div class="flex items-center justify-between gap-4">
      <div class="flex items-start gap-3 min-w-0">
        <div class="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
          <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/>
          </svg>
        </div>
        <div class="min-w-0">
          <h3 class="text-lg font-bold text-gray-800 truncate">{{ selectedTopic.title }}</h3>
          <p class="text-xs text-gray-400 truncate">{{ selectedOffering.subjectName }} · {{ selectedOffering.formName || selectedOffering.grade }}</p>
        </div>
      </div>
      <button
        (click)="openPublishModal()"
        class="flex items-center gap-2 px-4 py-2 rounded-xl bg-primary text-white text-sm font-semibold cursor-pointer hover:opacity-90 transition-opacity flex-shrink-0"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"/>
        </svg>
        Add Material
      </button>
    </div>

    <app-loader-component [loading]="materialsLoading" message="Loading materials..."></app-loader-component>

    <div *ngIf="materialsError && !materialsLoading" class="flex items-center gap-2 p-3 rounded-xl bg-red-50 border border-red-200 text-sm text-red-600">
      <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 8v4m0 4h.01"/></svg>
      {{ materialsError }}
    </div>

    <div *ngIf="!materialsLoading && !materialsError && materials.length === 0" class="flex flex-col items-center justify-center py-16 text-center">
      <svg class="w-10 h-10 text-gray-300 mb-3" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"/>
      </svg>
      <p class="text-sm font-medium text-gray-600">No materials yet</p>
      <p class="text-xs text-gray-400 mt-1">Click <strong>Add Material</strong> to publish the first resource for this topic.</p>
    </div>

    <div *ngIf="!materialsLoading && materials.length > 0" class="space-y-3">
      <div
        *ngFor="let material of materials"
        class="flex items-start gap-4 p-4 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 transition-colors"
      >
        <div
          class="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
          [style.background]="getMaterialTypeColor(material.materialType) + '18'"
        >
          <i
            [class]="'bi bi-' + getMaterialTypeIcon(material.materialType) + ' text-base'"
            [style.color]="getMaterialTypeColor(material.materialType)"
          ></i>
        </div>
        <div class="flex-1 min-w-0">
          <div class="flex items-center gap-2 flex-wrap">
            <p class="font-semibold text-gray-800 truncate">{{ material.title }}</p>
            <span
              class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-xs font-semibold border"
              [class.bg-green-50]="material.published" [class.text-green-700]="material.published" [class.border-green-200]="material.published"
              [class.bg-gray-100]="!material.published" [class.text-gray-500]="!material.published" [class.border-gray-200]="!material.published"
            >
              <span class="w-1.5 h-1.5 rounded-full inline-block" [class.bg-green-500]="material.published" [class.bg-gray-400]="!material.published"></span>
              {{ material.published ? 'Published' : 'Draft' }}
            </span>
            <span class="inline-block px-2 py-0.5 rounded-md bg-gray-100 border border-gray-200 text-xs font-semibold text-gray-500">
              {{ material.materialType }}
            </span>
          </div>
          <p *ngIf="material.description" class="text-xs text-gray-400 mt-1 line-clamp-2">{{ material.description }}</p>
        </div>
        <button
          (click)="openDeleteMaterialModal(material)"
          title="Delete material"
          class="p-1.5 rounded-lg hover:bg-red-50 text-gray-400 hover:text-red-600 cursor-pointer transition-colors flex-shrink-0"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"/>
          </svg>
        </button>
      </div>
    </div>

  </ng-container>

</div>


<!-- ══ PUBLISH MODAL ══ -->
<div *ngIf="showPublishModal" class="fixed inset-0 z-50 flex items-center justify-center p-4" (click)="closePublishModal()">
  <div class="absolute inset-0 bg-black/40"></div>
  <div class="relative w-full max-w-lg bg-white rounded-2xl shadow-2xl border border-gray-200 flex flex-col max-h-[90vh]" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 flex-shrink-0">
      <div>
        <h3 class="text-base font-bold text-gray-800">Add Material</h3>
        <p class="text-xs text-gray-400 mt-0.5">{{ selectedTopic?.title }}</p>
      </div>
      <button (click)="closePublishModal()" [disabled]="publishLoading" class="p-1.5 rounded-lg hover:bg-gray-100 text-gray-400 cursor-pointer transition-colors disabled:opacity-40">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/></svg>
      </button>
    </div>

    <!-- Stepper -->
    <div *ngIf="publishStep < 3" class="px-6 py-3 border-b border-gray-200 flex-shrink-0">
      <div class="flex items-center gap-2">
        <div class="flex items-center gap-2">
          <div class="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
            [class.bg-primary]="publishStep >= 1" [class.text-white]="publishStep >= 1"
            [class.bg-gray-100]="publishStep < 1" [class.text-gray-400]="publishStep < 1"
          >
            <svg *ngIf="publishStep > 1" class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>
            <span *ngIf="publishStep <= 1">1</span>
          </div>
          <span class="text-xs font-semibold" [class.text-primary]="publishStep === 1" [class.text-gray-400]="publishStep !== 1">Details</span>
        </div>
        <div class="flex-1 h-px bg-gray-200 mx-1"></div>
        <div class="flex items-center gap-2">
          <div class="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
            [class.bg-primary]="publishStep >= 2" [class.text-white]="publishStep >= 2"
            [class.bg-gray-100]="publishStep < 2" [class.text-gray-400]="publishStep < 2"
          >2</div>
          <span class="text-xs font-semibold" [class.text-primary]="publishStep === 2" [class.text-gray-400]="publishStep !== 2">File & Options</span>
        </div>
      </div>
    </div>

    <!-- Scrollable body -->
    <div class="flex-1 overflow-y-auto px-6 py-5 min-h-0">

      <div *ngIf="publishError" class="flex items-center gap-2 p-3 rounded-lg bg-red-50 border border-red-200 text-sm text-red-600 mb-4">
        <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 8v4m0 4h.01"/></svg>
        {{ publishError }}
      </div>

      <!-- STEP 1 -->
      <div *ngIf="publishStep === 1" class="space-y-4">

        <div class="space-y-1.5">
          <label class="text-xs font-semibold uppercase tracking-wider text-gray-400">Title <span class="text-red-400">*</span></label>
          <input
            type="text"
            [(ngModel)]="publishForm.title"
            placeholder="e.g. Introduction to Photosynthesis"
            class="w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-white text-sm text-gray-800 placeholder:text-gray-400 outline-none focus:border-primary transition-colors"
          />
        </div>

        <div class="space-y-1.5">
          <label class="text-xs font-semibold uppercase tracking-wider text-gray-400">Description <span class="normal-case font-normal text-gray-400">(optional)</span></label>
          <textarea
            [(ngModel)]="publishForm.description"
            rows="3"
            placeholder="What will students learn from this material?"
            class="w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-white text-sm text-gray-800 placeholder:text-gray-400 outline-none focus:border-primary transition-colors resize-none"
          ></textarea>
        </div>

        <div class="space-y-1.5">
          <label class="text-xs font-semibold uppercase tracking-wider text-gray-400">Content Type</label>
          <div class="grid grid-cols-3 gap-2">
            <button
              *ngFor="let type of materialTypes"
              (click)="onTypeChange(type.key)"
              class="flex flex-col items-center gap-1.5 p-3 rounded-xl border-2 text-xs font-semibold transition-all cursor-pointer"
              [class.border-primary]="publishForm.materialType === type.key"
              [class.bg-primary]="publishForm.materialType === type.key"
              [class.text-white]="publishForm.materialType === type.key"
              [class.border-gray-200]="publishForm.materialType !== type.key"
              [class.text-gray-600]="publishForm.materialType !== type.key"
              [class.bg-white]="publishForm.materialType !== type.key"
            >
              <i [class]="'bi bi-' + type.icon + ' text-lg'"></i>
              <span>{{ type.label }}</span>
            </button>
          </div>
        </div>

      </div>

      <!-- STEP 2 -->
      <div *ngIf="publishStep === 2" class="space-y-4">

        <div *ngIf="fileUploadAllowed" class="space-y-1.5">
          <label class="text-xs font-semibold uppercase tracking-wider text-gray-400">
            Upload File
            <span class="normal-case font-normal text-gray-400">(optional)</span>
            <span class="normal-case font-semibold" [style.color]="selectedMaterialType?.color"> · {{ selectedMaterialType?.label }}</span>
          </label>

          <div
            *ngIf="!selectedFile"
            class="relative border-2 border-dashed border-gray-200 rounded-xl p-8 text-center hover:border-primary transition-colors cursor-pointer group"
            (click)="fileInput.click()"
          >
            <input #fileInput type="file" class="hidden" [accept]="acceptedFileTypes" (change)="onFileSelected($event)" />
            <i [class]="'bi bi-' + (selectedMaterialType?.icon || 'upload') + ' text-3xl mb-2 block group-hover:text-primary transition-colors text-gray-300'"></i>
            <p class="text-sm text-gray-500 font-medium">Click to upload {{ selectedMaterialType?.label }}</p>
            <p class="text-xs text-gray-400 mt-1">
              <ng-container *ngIf="publishForm.materialType === 'PDF'">PDF files only</ng-container>
              <ng-container *ngIf="publishForm.materialType === 'VIDEO'">MP4 or WebM video</ng-container>
              <ng-container *ngIf="publishForm.materialType === 'IMAGE'">JPEG, PNG or WebP images</ng-container>
            </p>
          </div>

          <div *ngIf="selectedFile" class="flex items-center gap-3 p-3 rounded-xl border border-gray-200 bg-gray-50">
            <div class="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0 border border-gray-200 bg-white flex items-center justify-center">
              <img *ngIf="filePreviewUrl" [src]="filePreviewUrl" class="w-full h-full object-cover" />
              <i *ngIf="!filePreviewUrl" [class]="'bi bi-' + (selectedMaterialType?.icon || 'file-earmark') + ' text-gray-400'"></i>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-sm font-semibold text-gray-700 truncate">{{ selectedFile.name }}</p>
              <p class="text-xs text-gray-400">{{ formatBytes(selectedFile.size) }}</p>
            </div>
            <button (click)="removeFile()" class="p-1.5 rounded-lg hover:bg-red-50 text-gray-400 hover:text-red-600 cursor-pointer transition-colors flex-shrink-0">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/></svg>
            </button>
          </div>

          <div *ngIf="uploadProgress === 'uploading'" class="flex items-center gap-2 text-xs text-gray-500 px-1">
            <svg class="w-3.5 h-3.5 animate-spin text-primary" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>
            Uploading file...
          </div>
          <div *ngIf="uploadProgress === 'done'" class="flex items-center gap-2 text-xs text-green-600 px-1">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg>
            File uploaded successfully
          </div>
        </div>

        <div *ngIf="!fileUploadAllowed" class="flex items-center gap-2 p-3 rounded-xl border border-gray-200 bg-gray-50 text-sm text-gray-500">
          <svg class="w-4 h-4 flex-shrink-0 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"/></svg>
          <span *ngIf="publishForm.materialType === 'NOTE'">Notes are text-based — no file needed.</span>
          <span *ngIf="publishForm.materialType === 'LINK'">Links don't require a file upload.</span>
        </div>

        <label class="flex items-center gap-3 p-3 rounded-xl border border-gray-200 bg-gray-50 cursor-pointer hover:bg-gray-100 transition-colors select-none">
          <input type="checkbox" [(ngModel)]="publishForm.publish" class="w-4 h-4 rounded accent-primary cursor-pointer" />
          <div>
            <p class="text-sm font-semibold text-gray-700">Publish immediately</p>
            <p class="text-xs text-gray-400">Students will see this material right away</p>
          </div>
        </label>

        <label class="flex items-center gap-3 p-3 rounded-xl border border-gray-200 bg-gray-50 cursor-pointer hover:bg-gray-100 transition-colors select-none">
          <input type="checkbox" [(ngModel)]="publishForm.requestProcessing" class="w-4 h-4 rounded accent-primary cursor-pointer" />
          <div>
            <p class="text-sm font-semibold text-gray-700">Request AI processing</p>
            <p class="text-xs text-gray-400">Auto-generate summaries, quizzes or study notes</p>
          </div>
        </label>

        <div class="p-3 rounded-xl border border-gray-200 bg-gray-50 space-y-1.5">
          <p class="text-xs font-semibold uppercase tracking-wider text-gray-400">Summary</p>
          <div class="flex items-center justify-between text-sm">
            <span class="text-gray-500">Title</span>
            <strong class="text-gray-700 truncate max-w-48">{{ publishForm.title }}</strong>
          </div>
          <div class="flex items-center justify-between text-sm">
            <span class="text-gray-500">Type</span>
            <strong [style.color]="selectedMaterialType?.color">{{ selectedMaterialType?.label }}</strong>
          </div>
          <div class="flex items-center justify-between text-sm">
            <span class="text-gray-500">File</span>
            <strong class="text-gray-700">{{ selectedFile ? selectedFile.name : 'None' }}</strong>
          </div>
          <div class="flex items-center justify-between text-sm">
            <span class="text-gray-500">Visibility</span>
            <strong [class.text-green-600]="publishForm.publish" [class.text-gray-500]="!publishForm.publish">{{ publishForm.publish ? 'Published' : 'Draft' }}</strong>
          </div>
        </div>

      </div>

      <!-- STEP 3: Success -->
      <div *ngIf="publishStep === 3" class="flex flex-col items-center justify-center py-8 text-center">
        <div class="w-16 h-16 rounded-2xl bg-green-50 border border-green-200 flex items-center justify-center mb-4">
          <svg class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
          </svg>
        </div>
        <h4 class="text-base font-bold text-gray-800 mb-1">Material Added!</h4>
        <p class="text-sm text-gray-500 mb-1">
          <span class="font-semibold text-gray-700">{{ publishForm.title }}</span> has been added to
          <span class="font-semibold text-gray-700">{{ selectedTopic?.title }}</span>.
        </p>
        <p *ngIf="publishForm.publish" class="text-xs text-green-600 font-medium">Visible to students now.</p>
        <p *ngIf="!publishForm.publish" class="text-xs text-gray-400">Saved as draft — not yet visible.</p>
      </div>

    </div>

    <!-- Footer -->
    <div class="px-6 py-4 border-t border-gray-200 flex items-center justify-between flex-shrink-0">
      <button
        *ngIf="publishStep === 2 && !publishLoading"
        (click)="goToStep1()"
        class="px-4 py-2 rounded-xl border border-gray-200 text-sm font-semibold text-gray-600 cursor-pointer hover:bg-gray-50 transition-colors"
      >← Back</button>
      <div *ngIf="publishStep !== 2 || publishLoading"></div>

      <div class="flex items-center gap-3">
        <button
          *ngIf="publishStep < 3"
          (click)="closePublishModal()"
          [disabled]="publishLoading"
          class="px-4 py-2 rounded-xl border border-gray-200 text-sm font-semibold text-gray-600 cursor-pointer hover:bg-gray-50 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        >Cancel</button>

        <button *ngIf="publishStep === 1" (click)="goToStep2()"
          class="px-4 py-2 rounded-xl bg-primary text-white text-sm font-semibold cursor-pointer hover:opacity-90 transition-opacity">
          Continue →
        </button>

        <button
          *ngIf="publishStep === 2"
          (click)="submitPublish()"
          [disabled]="publishLoading"
          class="flex items-center gap-2 px-4 py-2 rounded-xl bg-primary text-white text-sm font-semibold cursor-pointer hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <svg *ngIf="publishLoading" class="w-4 h-4 animate-spin" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
            <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
          </svg>
          {{ publishLoading ? 'Publishing...' : 'Publish Material' }}
        </button>

        <button *ngIf="publishStep === 3" (click)="closePublishModal()"
          class="px-4 py-2 rounded-xl bg-primary text-white text-sm font-semibold cursor-pointer hover:opacity-90 transition-opacity">
          Done
        </button>
      </div>
    </div>

  </div>
</div>


<!-- ══ DELETE MATERIAL MODAL ══ -->
<div *ngIf="showDeleteMaterialModal" class="fixed inset-0 z-50 flex items-center justify-center p-4" (click)="closeDeleteMaterialModal()">
  <div class="absolute inset-0 bg-black/40"></div>
  <div class="relative w-full max-w-sm bg-white rounded-2xl shadow-2xl border border-gray-200 p-6 space-y-5" (click)="$event.stopPropagation()">

    <div class="flex items-start gap-4">
      <div class="w-10 h-10 rounded-xl bg-red-50 border border-red-200 flex items-center justify-center flex-shrink-0">
        <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
        </svg>
      </div>
      <div>
        <h3 class="text-base font-bold text-gray-800">Delete Material</h3>
        <p class="text-sm text-gray-600 mt-1">
          Are you sure you want to delete <span class="font-semibold">{{ selectedMaterial?.title }}</span>? This cannot be undone.
        </p>
      </div>
    </div>

    <div *ngIf="deleteMaterialError" class="flex items-center gap-2 p-3 rounded-lg bg-red-50 border border-red-200 text-sm text-red-600">
      <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 8v4m0 4h.01"/></svg>
      {{ deleteMaterialError }}
    </div>

    <div class="flex items-center justify-end gap-3">
      <button (click)="closeDeleteMaterialModal()" [disabled]="deleteMaterialLoading"
        class="px-4 py-2 rounded-xl border border-gray-200 text-sm font-semibold text-gray-600 cursor-pointer hover:bg-gray-50 transition-colors disabled:opacity-40 disabled:cursor-not-allowed">
        Cancel
      </button>
      <button (click)="confirmDeleteMaterial()" [disabled]="deleteMaterialLoading"
        class="flex items-center gap-2 px-4 py-2 rounded-xl bg-red-600 text-white text-sm font-semibold cursor-pointer hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed">
        <svg *ngIf="deleteMaterialLoading" class="w-4 h-4 animate-spin" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
          <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
        </svg>
        {{ deleteMaterialLoading ? 'Deleting...' : 'Yes, Delete' }}
      </button>
    </div>

  </div>
</div>